<div class="blue-body">
  <a  href="#" [ngClass]="{ 'btn disabled p-0': disabled }" (click)="getAuthorization($event)"
  [routerLink]="['/login']">
    <div class="row pl-0 pr-0">
      <div class="col-12">
        <header class="w-100 text-center header-index">
          <img src="assets/img/logo-home.png">
        </header>
        <img src="assets/img/img-home.jpg" class="mb-5">
        <div class="col-12 title-welcome text-center mt-5 mb-5">
          AHORRA TIEMPO
        </div>
        <div class="col-12 welcome text-center animated bounceIn infinite hardslower mt-5 ">
          Haz clic aquí
        </div>
      </div>
    </div>
  </a>
</div>
<app-footer></app-footer>